import styled from "styled-components";
import { colors } from "app/popleads/components/ui-kit/colors";

/**
 * The AI Assistant's palette inside the extension.
 *
 * These values mirror `components/Chat/AssistantDrawer.module.scss` so the CRM's assistant and this
 * one are visibly the same assistant. They are duplicated rather than shared because that side is
 * SCSS and this side is styled-components, and nothing in the build turns one into the other. **If
 * the accent changes there, it has to change here.**
 *
 * The accent is this shell's own `l3rnTech` — `[900]`/`[950]`/`[25]` — and the CRM window now takes
 * the same three values: the assistant wears the extension's colours in both shells. Before this it
 * borrowed a near-black from the CRM side so the two would read as one assistant; they still do,
 * the other way round. `muted` matches `$tertiary-color`, the CRM stylesheet's old caption colour.
 */
export const ai = {
    accent: colors.l3rnTech[900],
    accentStrong: colors.l3rnTech[950],
    accentTint: colors.l3rnTech[25],

    ink: colors.neutral[900],
    muted: "#8a9eb4", // $tertiary-color in AssistantDrawer.module.scss
};

/**
 * A failure, in the assistant's own frame rather than as a toast. The question is still on screen
 * behind this, so the message says so and the control offers the one useful next step.
 *
 * Border and fill are AssistantDrawer.module.scss's .failure literal hex, not
 * colors.danger[200]/[50] — close but not identical, and this box is meant to be the same failure
 * state in both shells, not each shell's own reading of "a light red."
 */
export const AssistantFailure = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    box-sizing: border-box;
    width: 100%;
    padding: 12px;
    border: 1px solid #f1d6da;
    border-radius: 12px;
    background-color: #fdf6f7;
`;

export const AssistantFailureText = styled.span`
    color: #b93d48;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
`;
